import { isShadowRoot as a, isHTMLElement as s } from "./atoms-v2782.js";
function p(t) {
  let n = t.activeElement;
  for (; ((r = n) == null || (r = r.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var r;
    n = n.shadowRoot.activeElement;
  }
  return n;
}
function m(t, n) {
  if (!t || !n)
    return !1;
  const r = n.getRootNode == null ? void 0 : n.getRootNode();
  if (t.contains(n))
    return !0;
  if (r && a(r)) {
    let o = n;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function i() {
  const t = navigator.userAgentData;
  return t != null && t.platform ? t.platform : navigator.platform;
}
function u() {
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map((n) => {
    let {
      brand: r,
      version: o
    } = n;
    return r + "/" + o;
  }).join(" ") : navigator.userAgent;
}
function g(t) {
  return t.mozInputSource === 0 && t.isTrusted ? !0 : e() && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function h(t) {
  return c() ? !1 : !e() && t.width === 0 && t.height === 0 || e() && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function b() {
  return /apple/i.test(navigator.vendor);
}
function e() {
  const t = /android/i;
  return t.test(i()) || t.test(u());
}
function E() {
  return i().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function c() {
  return u().includes("jsdom/");
}
function T(t, n) {
  const r = ["mouse", "pen"];
  return n || r.push("", void 0), r.includes(t);
}
function y(t) {
  return "nativeEvent" in t;
}
function w(t) {
  return t.matches("html,body");
}
function P(t) {
  return (t == null ? void 0 : t.ownerDocument) || document;
}
function A(t, n) {
  if (n == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(n);
  const r = t;
  return r.target != null && n.contains(r.target);
}
function D(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
const l = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function f(t) {
  return s(t) && t.matches(l);
}
function R(t) {
  t.preventDefault(), t.stopPropagation();
}
function x(t) {
  return t ? t.getAttribute("role") === "combobox" && f(t) : !1;
}
export {
  l as TYPEABLE_SELECTOR,
  p as activeElement,
  m as contains,
  P as getDocument,
  i as getPlatform,
  D as getTarget,
  u as getUserAgent,
  e as isAndroid,
  A as isEventTargetWithin,
  c as isJSDOM,
  E as isMac,
  T as isMouseLikePointerType,
  y as isReactEvent,
  w as isRootElement,
  b as isSafari,
  x as isTypeableCombobox,
  f as isTypeableElement,
  g as isVirtualClick,
  h as isVirtualPointerEvent,
  R as stopEvent
};
